import { useEffect, useState } from "react";
import { api, timeAgo } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";

export default function PartnerEnquiries() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/partner-interest").then((r) => setRows(r.data)).catch(() => {}); }, []);
  return (
    <Card data-testid="partner-enquiries-card">
      <CardHeader>
        <CardTitle className="font-display text-2xl">Regional Partner enquiries ({rows.length})</CardTitle>
        <CardDescription>From the Become a Regional Partner page. You also get each one by email.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-2">
        {rows.length === 0 && <div className="text-sm text-slate-500">No enquiries yet.</div>}
        {rows.map((r) => (
          <div key={r.id} className="border border-slate-200 rounded-xl p-3 text-sm" data-testid={`enquiry-${r.id}`}>
            <div className="font-semibold">{r.name} · <span className="text-emerald-800">{r.region}</span> <span className="text-xs text-slate-400 font-normal">{timeAgo(r.created_at)}</span></div>
            <div className="text-xs text-slate-500">{r.email}{r.phone && ` · ${r.phone}`}</div>
            {r.message && <p className="mt-1 text-slate-700 whitespace-pre-wrap">{r.message}</p>}
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
